import { PriorityFilterStatus } from "@/enum/list.enum";

/**
 * Every lead-priority filter option, in the order the dropdowns list them.
 *
 * The list table, the Inbox, Review-to-send, Compose and a campaign's lead-priority step all offer
 * this one set (the Feed offers the same values through `FEED_LEAD_SCORE_FILTERS`). Each of them
 * used to spell the options out inline, so a bucket added to the enum, such as PREC-4075's "?",
 * would have had to be remembered five times.
 */
export const PRIORITY_FILTER_OPTIONS: readonly PriorityFilterStatus[] = [
	PriorityFilterStatus.ALL,
	PriorityFilterStatus.ALL_WITH_PRIORITY,
	PriorityFilterStatus.P1,
	PriorityFilterStatus.P2,
	PriorityFilterStatus.P3,
	PriorityFilterStatus.DQ,
	PriorityFilterStatus.UNSURE,
];

/** The dropdown items for {@link PRIORITY_FILTER_OPTIONS}, titled by `label`. */
export const toPriorityFilterItems = (
	label: (status: PriorityFilterStatus) => string
): { id: PriorityFilterStatus; title: string }[] =>
	PRIORITY_FILTER_OPTIONS.map((status) => ({ id: status, title: label(status) }));
